import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Title } from '@/components/Typography';
import { useRosaResultContext } from '../context';
import { Card } from '../../../components/CardResults';

export function SectionScore() {
	const {
		rosaResult: {
			scores: { section_a, section_b, section_c, section_d }
		}
	} = useRosaResultContext();

	const sections_scores = [
		{ id: 1, name: `${I18n.get('Section')} A`, score: section_a, description: `${I18n.get('Chair')}` },
		{ id: 2, name: `${I18n.get('Section')} B`, score: section_b, description: `${I18n.get('Monitor and Phone')}` },
		{ id: 3, name: `${I18n.get('Section')} C`, score: section_c, description: `${I18n.get('Mouse and Keyboard')}` },
		{
			id: 4,
			name: `${I18n.get('Section')} D`,
			score: section_d,
			description: `${I18n.get('Peripherals and Monitor')}`
		}
	];

	return (
		<Row gutter={[40, 10]}>
			<Col span={24}>
				<Title level={5}>{I18n.get('Scoring by section')}</Title>
			</Col>
			{sections_scores.map((section) => (
				<Col key={section.id} span={6}>
					<Card
						key={section.id}
						title={section.name}
						score={section.score}
						description={section.description}
					/>
				</Col>
			))}
		</Row>
	);
}
